module.exports = __webpack_public_path__ + "img/KSC07538.a2378267.jpg";